<app-data-grid
  [mode]="locked ? 'view' : 'edit'"
  [state]="state"
  [fontSize]="fontSize"
  (valueChange)="cacheChanges()"
  [columns]="columns"
  [dataItems]="changeset"
  [filterable]="'menu'"
  (dataStateChange)="fetchChangesets($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    columnTemplate
    let-column="column"
    let-row="row"
    field="itemPrice"
  >
    <span class="k-d-flex k-justify-content-center">
      <app-column [fontSize]="fontSize" [data]="row" [column]="column">
      </app-column>

      <button
        kendoButton
        size="small"
        (click)="currentComponentId = row.componentId"
        fillMode="link"
        themeColor="primary"
      >
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
        Custom
      </button>
    </span>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="plu"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    columnTemplate
    field="itemName"
    let-row="row"
    let-column="column"
  >
    {{ row[column.field] }}
    <button
      *ngIf="row.status == 'Pending Pricing'"
      kendoButton
      [title]="'This item is pending sync to PAR'"
      class="m-l-4 info-bg badge-button"
      size="small"
      rounded="full"
    >
      Pending
    </button>

    <button
      *ngIf="row.hasDirty()"
      kendoButton
      [title]="'This item has unsaved changes'"
      class="m-l-4 warning-bg badge-button"
      size="small"
      rounded="full"
    >
      Unsaved
    </button>

    <button
      *ngIf="row.status == 'Scheduled Pricing'"
      kendoButton
      [title]="'This item is scheduled to sync with PAR'"
      class="m-l-4 success-bg badge-button"
      size="small"
      rounded="full"
    >
      Scheduled
    </button>
  </ng-template>

  <ng-template
    columnTemplate
    field="deliveryPrice"
    let-row="row"
    let-column="column"
  >
    <p
      *ngIf="row.deliveryPrice == null"
      [style.textAlign]="column.align || 'center'"
      class="m-0 italic-text"
      kendoTooltip
      title="In-store price applied by default"
    >
      {{ row.itemPrice | currency: "USD" }}
    </p>
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.deliveryPrice != null"
    >
    </app-column>
  </ng-template>

  <ng-template     
    columnTemplate
    field="newDeliveryPrice"
    let-row="row"
    let-column="column">
      <app-editable-column
        kendoTooltip
        *ngIf="!locked"
        [title]="row.isDeliveryAvailable == false ? 'This item is not available for delivery pricing.': ''"
       [fontSize]="fontSize"
       [dataItem]="row"
       [column]="column"
       (valueChange)="onValueChange($event.dataItem, $event.field)"
       [disabled]="row.isDeliveryAvailable == false"
        [placeholder]="row.isDeliveryAvailable == false ? 'N/A' : ''"
     ></app-editable-column>

      <app-column
      *ngIf="locked"
       [fontSize]="fontSize"
       [data]="row"
       [column]="column"
       ></app-column>
  </ng-template>
</app-data-grid>

<kendo-dialog
  *ngIf="currentComponentId != null && restaurantId != null"
  (close)="currentComponentId = null"
  title="Override Prices"
>
  <app-override-grid
    [locked]="locked"
    [componentId]="currentComponentId"
    [restaurantId]="restaurantId"
    [productType]="productTypeId"
  ></app-override-grid>
</kendo-dialog>
